import { ErrorMessage, Field, Formik, useFormik, Form } from "formik";
import { useEffect, useState, useRef } from "react";
import { Card,Button,Collapse,  Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION, CREATENEW,DELETE, CANCEL, ACTIVE, INACTIVE } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import Modalpopup from "../../../shared/components/Modalpopup";
import { loadNotificationDataRequest, loadNotificationGetDataRequest, loadNotificationDeleteDataRequest } from "../redux/Actions";
import ListView from "../../../shared/components/listview/ListView"
import Breadcrumbs from "../../../shared/components/Breadcrumbs"
import Permissions from "../../../shared/components/Permissions"

const Notification = () => {      
    const dispatch = useDispatch();
    let navigate = useNavigate();
    let {notification, notify} = useSelector(state => state.notification);
    let [clickEditFunc, setClickEditFunc] = useState(null);
    let [selectedRow, setSelectedRow] = useState({});
    let [clickStatusFunc, setClickStatusFunc] = useState(null);
    let [showStatusModal, setShowStatusModal] = useState(false);
    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Notification";
    let permission = Permissions(emp_no, module_name);
    let actionsPermission = !(permission.write_permission || permission.delete_permission);
    const [reload, setReload] = useState(false);    

   useEffect(() =>{
        dispatch(loadNotificationDataRequest());
    },[dispatch]);    
    

    const columnDefs = [
        {
            display_name: "Id",
            field: "id",
            type: "number",
            hide: true,
        },
        {
            display_name: "Acknowledgement Header",
            field: "ack_header",
            type: "text"
        },
        {
            display_name: "Application",
            field: "application",
            type: "text"
        },
        {
            display_name: "Max By Pass",
            field: "bypass_max",
            type: "text",
        },
        {
            display_name: "Acknowledgement Type",
            field: 'ack_type',
            type: "text",
        
        },
        {
            display_name: 'Start Date',
            field: 'start_date',
            type: 'date',
            valueFormatter: ({ value }) => value ? new Date(value).toLocaleDateString() : ''
        },
        {
            display_name: 'End Date',
            field: 'end_date',
            type: 'date',
            valueFormatter: ({ value }) => value ? new Date(value).toLocaleDateString() : ''
        },
        
        {
            display_name: 'Actions',
            field: 'actions',
            hide: actionsPermission,
        }   
    ]

    useEffect(() => {        
            setClickEditFunc(() => (row) => {
                setSelectedRow(row);
                dispatch(loadNotificationGetDataRequest(row.id));
                navigate(`/notification/form/${row.id}`);
                setReload(prev => !prev); 
            });   
        }, [dispatch, navigate]);

    useEffect(() => {        
        setClickStatusFunc(
            () => (row) => {
                setSelectedRow(row);
                setShowStatusModal(true);
                
            })   
    }, [])
 
    
    const handleStatus = async (row) => {
        await dispatch(loadNotificationDeleteDataRequest(row.id));
        setReload(prev => !prev); 
        setShowStatusModal(false);
    };


    return <>       
    <Row className="align-items-center mb-2">
      <Col>
        <Breadcrumbs
          children={[
            { href: '/notification', label: NOTIFICATION },
          ]}
        />
      </Col>
      <Col className="d-flex justify-content-end">
        {permission.create_permission ?(
        <DefaultButton
          buttonClass="default-btn-color"
          buttonTitle={CREATENEW}
          actionBlock={() => { navigate('./add'); }}
        />) : (<></>)}
      </Col>
    </Row>
        <ListView            
            columnNames={columnDefs}
            rowData={notification.data} 
            clickEdit={clickEditFunc}
            clickStatus={clickStatusFunc}
        />  
        <Modalpopup height="80vh" size="lg"  show={showStatusModal}  handleClose={() => setShowStatusModal(false)} actionTitle="Status Update">
                <p>
                    {selectedRow?.status
                    ? <>Do you want to make <strong>{selectedRow?.ack_header}</strong> inactive?</>
                    : <>Do you want to make <strong>{selectedRow?.ack_header}</strong> active?</>
                    }
                </p>

                <div className="col-md-12">
                    <DefaultButton
                    buttonClass="btn btn-secondary me-2"
                    buttonTitle={CANCEL}
                    actionBlock={() => setShowStatusModal(false)}
                    />
                    <DefaultButton
                    buttonClass={selectedRow?.status ? "btn btn-danger" : "btn btn-success"}
                    buttonTitle={selectedRow?.status ? INACTIVE : ACTIVE}
                    actionBlock={() => handleStatus(selectedRow)}
                    />
                </div>
        </Modalpopup>

        
           
    </>
}

export default Notification;
